module.exports = function _promisify(orig) {
  return function(...args) {
    return new Promise(function(resolve, reject) {
      function errback(err, result) {
        if (err) {
          reject(err)
        }
        else {
          resolve(result)
        }
      }
      args.push(errback)
      orig.apply({}, args)
    })
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/slack/src/_promisify.js
// module id = 171
// module chunks = 1